import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';
import TextField from '../components/TextField';
import Snackbar from '../components/Snackbar';
import Button from '../components/Button';
import Wave from '../../static/modern-professional/blue-7914536_1280.jpg';


function ProductCTA() {
  const [open, setOpen] = React.useState(false);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container component="section" sx={{ mt: 20, display: 'flex' }}>
      <Grid container>
        <Grid item xs={12} md={6} sx={{ zIndex: 1 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              bgcolor: 'white',
              py: 6,
              px: 3,
              border: '2px solid', // You can adjust the border width
              borderColor: 'primary.main', // Change this to your desired border color
            }}
          >
            <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 400 }}>
              <Typography variant="h4" component="h2" gutterBottom>
                Our Vision
              </Typography>
              <Typography variant="h5">
              </Typography>
              <Typography variant="h5" sx={{ fontSize: 19 }}>
                グローバル化の波と共に、英語の必要性が一段と高まっていますが、英語学習自体は過去50年さほどかわりませんでした。
                テクノロジーやサイエンスの進歩によって、言語学習のメカニズムがわかってきた今、英語学習法自体も進化するときです。
                <br />
                <br />
                我々の提案する「音素学習」をきっかけに、多くの日本人の英語学習法ならびに英語力が根本的に変わること。
                それを通じて、多くの日本人が複雑化するグローバルな課題解決にもっともっと貢献していくこと。それが私たちの目指す世界です。

              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{ display: { md: 'block', xs: 'none' }, position: 'relative' }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: -67,
              left: -67,
              right: 0,
              bottom: 0,
              width: '100%',
              background: 'url(/static/themes/onepirate/productCTAImageDots.png)',
            }}
          />
          <Box
            component="img"
            src={Wave}
            alt="call to action"
            sx={{
              position: 'absolute',
              top: -70,
              left: -28,
              right: 0,
              bottom: 0,
              width: '100%',
              maxWidth: 600,
            }}
          />
        </Grid>
      </Grid>
      <Snackbar
        open={open}
        closeFunc={handleClose}
        message="We will send you our best offers, once a week."
      />
    </Container>
  );
}

export default ProductCTA;
